import { useContext } from 'react';
import CategoryContext from 'contexts/ListingType/components/CategoryPage/components/CategoryContext';

export default function useQuickFilters() {
    const { state } = useContext(CategoryContext);

    const quickFilters =
        state &&
        state.category &&
        state.category.context &&
        state.category.context.quickFilters
            ? state.category.context.quickFilters
            : null;

    return [quickFilters];
}
